import styled from "styled-components";
import bannerSrc from "../../assets/images/banner-home.jpeg";
import { Header } from "../../components/Header";
import { Container } from "../../theme/styles";
import { Footer } from "../../components/Footer";
import { MainBanner } from "../../components/MainBanner";
import { Link } from "react-router-dom";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";

function NotFound() {
  usePageTrack();

  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} />
      <FirstContent>
        <Welcome>
          <WelcomeTitle>Em Construção</WelcomeTitle>
          <WelcomeText>Essa página ainda está em desenvolvimento.</WelcomeText>
          <WelcomeButton to="/"><span>Retornar para Home</span></WelcomeButton>
        </Welcome>
      </FirstContent>
      <span></span>
      <Footer />
    </>
  );
}

export default NotFound;

const FirstContent = styled(Container)`
  display: flex;
  padding: 0 36px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    height: 62vh;
  }
`;

const Welcome = styled.div`
  padding: 32px 32px 32px;
  max-width: 500px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 32px 0;
    text-align: center;
    margin: auto;
  }
`;

const WelcomeTitle = styled.h1`
  font-size: 36px;
  color: ${({ theme }) => theme.colors.blue.dark };
  margin-bottom: 32px;
`;

const WelcomeText = styled.p`
  color: ${({ theme }) => theme.colors.gray.darker };
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 32px;
`;

const WelcomeButton = styled(Link)`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.blue.dark };
  color: ${({ theme }) => theme.colors.pink.light };
  text-decoration: none;
  text-transform: uppercase;
  width: 350px;
  height: 60px;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 100%;
  }
`;